import { render, staticRenderFns } from "./commuInfo.vue?vue&type=template&id=8018e29c"
import script from "./commuInfo.vue?vue&type=script&lang=js"
export * from "./commuInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports